import React from "react";
import { Link } from "@quintype/components";
import { object, array } from "prop-types";

import "./storyTag.m.css";

const Tag = ({ tag }) => (
  <Link
    href={"/topic/" + tag.slug}
    styleName="story-tag"
    data-testid="story-tags"
    data-tracking-category="Story Tag"
    data-tracking-action="Click"
    data-tracking-label={tag.name}
  >
    {tag.name}
  </Link>
);

Tag.propTypes = {
  tag: object,
};

const StoryTag = ({ tags = [] }) => (
  <ul styleName="story-tag-list">
    {tags.map((tag, index) => (
      <li styleName="tag-element" key={index}>
        <Tag tag={tag} />
      </li>
    ))}
  </ul>
);

StoryTag.propTypes = {
  tags: array,
};

export default StoryTag;
